import UserProfile from "./MyInfo";

const index = () => {
  return <UserProfile />;
};

export default index;
